import { render } from "./VetConsultation.vue?vue&type=template&id=068422ee&scoped=true"
import script from "./VetConsultation.vue?vue&type=script&lang=js"
export * from "./VetConsultation.vue?vue&type=script&lang=js"

import "./VetConsultation.vue?vue&type=style&index=0&id=068422ee&lang=css"
import "./VetConsultation.vue?vue&type=style&index=1&id=068422ee&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-068422ee"]])

export default __exports__